export default __webpack_public_path__ + "static/media/icon-care-admin-patient-consultations-new.01af128c.svg";